import React from "react";
import "../Slider/Slider.css";
import { Link } from "react-router-dom";

const places = [
  {
    image: "/demov.webp",
    listings: "2 Listings",
    location: "Rome",
    type: "Travel to",
    offer: "20% OFF",
  },
  {
    image: "/italy.avif",
    listings: "5 Listings",
    location: "Italy",
    type: "Places in",
    offer: "Limited Offer",
  },
  {
    image: "/france.avif",
    listings: "3 Listings",
    location: "France",
    type: "Places in",
    offer: "10% OFF",
  },
  {
    image: "/maldives.avif",
    listings: "3 Listings",
    location: "Maldives",
    type: "Travel to",
    offer: "Summer Deal",
  },
];

const Slider = () => {
  return (
    <div className="slider-section">
      <div className="left-panel">
        <p>DESTINATION LIST</p>
        <h1>Explore the Beautiful Places Around World</h1>
        <Link to="/contactus">
          <button className="contact-btn">Contact Now</button>
        </Link>
      </div>
      <div className="right-slider">
        <div className="slider-container">
          {places.map((place, index) => (
            <div
              className={`card ${index % 2 === 1 ? "highlighted" : ""}`}
              key={index}
            >
              <div className="image-wrapper">
                <img src={place.image} alt={place.location} />
                <span className="offer-tag">{place.offer}</span>
              </div>
              <div className="card-info">
                <span className="type-text">{place.type}</span>
                <h2>{place.location}</h2>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Slider;
